/**
 * A nav count in the portal's own digits: Arabic-Indic in Arabic ("٢"),
 * Western in English ("2"), or whatever numbering system the tag pins.
 *
 * `Intl` resolves a BARE `ar` to the `latn` numbering system, so `ar` is
 * pinned to `ar-EG` (the same rule as the seller app's `intlLocale`). With no
 * locale given, the document's `<html lang>` is used — every portal's intl
 * provider mirrors its locale there.
 *
 * A tag that names its own numbering system (`-u-nu-…`) is kept as given:
 * the restaurant portal passes `ar-EG-u-nu-latn` (its Western-digits rule).
 */
export function navCountLocale(locale?: string): string | undefined {
  const lang =
    locale ??
    (typeof document !== "undefined" ? document.documentElement.lang : "");
  if (!lang) return undefined;
  if (lang.includes("-u-nu-")) return lang;
  return lang === "ar" || lang.startsWith("ar-") ? "ar-EG" : lang;
}

export function formatNavCount(value: number, locale?: string): string {
  return new Intl.NumberFormat(navCountLocale(locale)).format(value);
}
